/* eslint-env browser */
/* eslint-disable import/imports-first */
require('styles/tandem.less');

import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { ReduxRouter } from 'redux-router';
import cookieStorage from 'cookiestorage';
import configureStore from './store/configureStore';

const store = configureStore();
const appElement = document.getElementById('app');

window.react_ga = require('react-ga');

if (window.SEND_GA === '1') {
  window.react_ga.initialize('UA-78812767-1', { debug: false });
  window.react_ga.plugin.require('linkid');
  window.react_ga.pageview(window.location.pathname);
}

// Shim fallback that covers errors in older safari and private browsing mode
try {
  localStorage.setItem('test_item', 'test');
  localStorage.removeItem('test_item');
  window.persistStore = localStorage;
} catch (e) {
  window.persistStore = cookieStorage(document);
}

render(
  <Provider store={store}>
    <ReduxRouter />
  </Provider>,
  appElement
);



// WEBPACK FOOTER //
// ./src/app/index.js